export default "__VITE_ASSET__BU6tKGam__"